let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("68yz2")).then(() => parcelRequire('3KwDQ'));